import cntl from "cntl";
import { Checkbox } from "../atoms";
import PropTypes from "prop-types";
import ButtonGrey from "../atoms/ButtonGrey";
import ButtonError from "../atoms/ButtonError";
import ButtonPrimary from "../atoms/ButtonPrimary";
import { useMemo, useState, cloneElement } from "react";
import { BUTTON_VARIANTS, COLOR, MODAL_ACTION_VARIANTS, SIZE } from "../constants";

const propTypes = {
  iconLink: PropTypes.object,
  labelLink: PropTypes.string,
  className: PropTypes.string,
  onClickLink: PropTypes.func,
  hasPaddingTop: PropTypes.bool,
  hasBorderTop: PropTypes.bool,
  labelCheckbox: PropTypes.string,
  labelSubmitBtn: PropTypes.string,
  labelCancelBtn: PropTypes.string,
  onClickSubmitBtn: PropTypes.func,
  onChangeCheckbox: PropTypes.func,
  onClickCancelBtn: PropTypes.func,
  disabledSubmitBtn: PropTypes.bool,
  color: PropTypes.oneOf([COLOR.primary, COLOR.error]),
  variant: PropTypes.oneOf([
    MODAL_ACTION_VARIANTS.row,
    MODAL_ACTION_VARIANTS.column,
    MODAL_ACTION_VARIANTS.other_actions,
  ]),
};

function ModalAction({
  color,
  variant,
  iconLink,
  className,
  labelLink,
  onClickLink,
  labelCheckbox,
  labelSubmitBtn,
  labelCancelBtn,
  onClickSubmitBtn,
  onChangeCheckbox,
  onClickCancelBtn,
  hasBorderTop = false,
  disabledSubmitBtn = false,
}) {
  const [width, setWidth] = useState("");
  const [direction, setDirection] = useState("");

  const actionCn = () => cntl`
    flex
    gap-3
    items-center
    justify-between
    ${direction}
    ${className ? className : undefined}
    ${
      hasBorderTop
        ? cntl`border-t border-t-grey-200 p-4 pt-4 mt-6 sm:p-6 sm:pt-6 sm:mt-8`
        : cntl`p-4 pt-6 sm:p-6 sm:pt-8`
    }
  `;

  const buttonCn = () => cntl`
    ${width}
  `;

  const buttonsCn = () => cntl`
    flex
    gap-3
    ${width}
    ${direction}
  `;

  const checkboxAndLinkCn = () => cntl`
    flex
    w-full
    gap-x-3
    flex-row
    items-center
    justify-between
    sm:justify-start
  `;

  const iconLinkCn = () => cntl`
    w-5
    h-5
    text-grey-500
  `;

  const linkCn = () => cntl`
    flex
    gap-x-1
    flex-row
    text-base
    items-center
    font-semibold
    text-grey-500
    cursor-pointer
  `;

  const button = useMemo(() => {
    switch (color) {
      case COLOR.primary:
        return <ButtonPrimary size={SIZE.lg} label={labelSubmitBtn} onClick={onClickSubmitBtn} />;
      case COLOR.error:
        return <ButtonError size={SIZE.lg} label={labelSubmitBtn} onClick={onClickSubmitBtn} />;
      default:
        return <ButtonPrimary size={SIZE.lg} label={labelSubmitBtn} onClick={onClickSubmitBtn} />;
    }
  }, [color, labelSubmitBtn, onClickSubmitBtn]);

  useMemo(() => {
    switch (variant) {
      case MODAL_ACTION_VARIANTS.row:
        setWidth("w-full");
        setDirection("flex-row");
        break;
      case MODAL_ACTION_VARIANTS.column:
        setWidth("w-full");
        setDirection("flex-col-reverse sm:flex-col-reverse");
        break;
      case MODAL_ACTION_VARIANTS.other_actions:
        setWidth("w-full sm:w-[initial]");
        setDirection("flex-col-reverse sm:flex-row");
        break;
      default:
        setWidth("w-full");
        setDirection("flex-row");
        break;
    }
  }, [variant]);

  return (
    <div className={actionCn()}>
      {variant === MODAL_ACTION_VARIANTS.other_actions && (
        <div className={checkboxAndLinkCn()}>
          <Checkbox
            size={SIZE.sm}
            name={labelCheckbox}
            label={labelCheckbox}
            id="modal-action-checkbox"
            onChange={onChangeCheckbox}
          />
          <div className={linkCn()} onClick={onClickLink}>
            {cloneElement(iconLink, { className: iconLinkCn() })}
            {labelLink}
          </div>
        </div>
      )}
      <div className={buttonsCn()}>
        <ButtonGrey
          label={labelCancelBtn}
          className={buttonCn()}
          onClick={onClickCancelBtn}
          variant={BUTTON_VARIANTS.border}
        />
        {cloneElement(button, {
          size: SIZE.lg,
          className: buttonCn(),
          label: labelSubmitBtn,
          onClick: onClickSubmitBtn,
          disabled: disabledSubmitBtn,
        })}
      </div>
    </div>
  );
}

ModalAction.propTypes = propTypes;
export default ModalAction;
